import { usePackageNamesOf } from '@/features/packages/packageNames';

/**
 * A work-area page's name in the bar of a phone and in the window title: the page's own words, and
 * for a page an installed package made, the package's name in the reader's language (I-1977), as
 * the sidebar and the page's own header already say it. The route read the stored English title
 * until now, so a German phone read the English name over a page headed with the German one.
 *
 * `title` is the page's stored title, or undefined where the route names no page.
 */
export function useDashboardPageTitle(
  title: string | undefined,
  workAreaId: string | null | undefined,
): string | undefined {
  const packageName = usePackageNamesOf(workAreaId);
  // I-2088: no title until the package's words in the reader's language are in, never the English first.
  return title === undefined || packageName.loading ? undefined : packageName(title);
}
